<mat-form-field appearance="fill">
  <mat-label>Select QR Type</mat-label>
  <mat-select [(ngModel)]="qrType" name="food">
    <mat-option value="1"> Evaluator E-Signature QR</mat-option>
    <mat-option value="2"> Work Permit QR </mat-option>
  </mat-select>
</mat-form-field>

<ng-container *ngIf="qrType">
  <ngx-scanner-qrcode
    #action="scanner"
    (event)="onEvent($event, action)"
  ></ngx-scanner-qrcode>

  <p *ngIf="action.isLoading">⌛ Loading...</p>

  <button
    class="btn"
    [class.btn-info]="!action.isStart"
    [class.btn-warning]="action.isStart"
    [disabled]="action.isLoading"
    (click)="handle(action, action.isStart ? 'stop' : 'start')"
  >
    <img
      [src]="
        action.isStart
          ? 'https://id1945.github.io/images/svg/camera-off.svg'
          : 'https://id1945.github.io/images/svg/camera-on.svg'
      "
      width="30px"
    />
  </button>
</ng-container>
